import React, { Component } from 'react'

import imgPhone from './phone.png'
import s from './Mockup.scss'
import cn from 'classnames'

// Export the src image from chrome using the Iphone 6 Plus size

export default class Mockup extends Component {
  render() {
    const { src, className, alt, ...otherProps } = this.props
    return (
      <div className={cn(s.mockup, className)} {...otherProps}>
        <img className={s.content} src={src} />
        <img className={s.frame} src={imgPhone} alt={alt} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Mockup/Mockup.jsx